import React from "react";

import {
  FloatingWindowInternal,
  useFloatingWindowPosition,
} from "src/base-components/FloatingWindow/FloatingWindow";
import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { FloatingWindowProps } from "src/base-components/FloatingWindow/store";
import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import { Button } from "src/design-system/Button";
import { copyTextToClipboard } from "src/utils/clipboard";

export type SystemPromptWindowData = {
  title: string;
  content: string;
};

export const SystemPromptButton: React.FC<{
  systemPrompt: string;
  sessionId: string;
}> = ({ systemPrompt, sessionId }) => {
  const { open: openWindow } = useFloatingWindowsActions();

  const handleClick = () => {
    openWindow(
      {
        id: `system-prompt-${sessionId}`,
        type: "system-prompt",
        target: undefined,
      },
      {
        title: "System prompt",
        content: systemPrompt,
      } satisfies SystemPromptWindowData,
    );
  };

  return (
    <Button
      dataLoc="open-system-prompt-window"
      size="sm"
      variant="secondary"
      onClick={handleClick}
    >
      View system prompt
    </Button>
  );
};

export const SystemPromptWindow: React.FC<FloatingWindowProps> = ({
  computePosition,
  id,
  data,
}) => {
  const { close: closeWindow } = useFloatingWindowsActions();
  const { position, windowRef } = useFloatingWindowPosition(computePosition);

  const typedData = data as SystemPromptWindowData;

  return (
    <FloatingWindowInternal
      ref={windowRef}
      dataLoc="system-prompt-window"
      height="h-120"
      id={id}
      style={{
        inset: "0px auto auto 0px",
        transform: position,
      }}
      title={typedData.title}
      width="w-150"
      draggable
      maximizable
      resizeable
      isPinned
      onClose={() => closeWindow(id)}
      onCopy={() => copyTextToClipboard(typedData.content)}
    >
      <div className="decideScrollbar h-full overflow-y-auto p-4 pt-2">
        <MarkdownRenderer content={typedData.content} />
      </div>
    </FloatingWindowInternal>
  );
};
